import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const MainSection = lazy(() => import('@/pages/mainSection'));
const TopBannerList = lazy(() => import('@/pages/mainSection/topBanner/TopBannerList'));
const NoticeList = lazy(() => import('@/pages/mainSection/notices/NoticeList'));
const NoticeDetail = lazy(() => import('@/pages/mainSection/notices/NoticeDetail'));
const FaqList = lazy(() => import('@/pages/mainSection/faq/FaqList'));
const FaqDetail = lazy(() => import('@/pages/mainSection/faq/FaqDetail'));

// 메인 섹션 라우트
export const mainSectionRoutes: TypedRouteObject = {
	path: ROOTS.MAIN_SECTION,
	element: withSuspense(MainSection),
	handle: {
		title: '메인섹션 관리',
		subTitle: '락앤런 메인페이지 컨텐츠 관리',
		permission: 'MAIN_SECTION' as const
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		{
			path: paths.mainSection.topBanner.list.path,
			element: withSuspense(TopBannerList),
			handle: {
				title: '메인 최상단 배너 노출 관리',
				subTitle: '메인섹션 > 최상단 배너 > 최상단 배너 목록'
			}
		},
		// 공지사항
		{
			path: paths.mainSection.notice.list.path,
			element: withSuspense(NoticeList),
			handle: {
				title: '공지사항',
				subTitle: '락앤런 공지사항'
			}
		},
		{
			path: paths.mainSection.notice.detail.path,
			element: withSuspense(NoticeDetail),
			handle: {
				isGoBack: true,
				title: '공지사항 상세정보',
				subTitle: '메인섹션 > 공지사항 > 상세정보'
			}
		},
		// FAQ
		{
			path: paths.mainSection.faq.list.path,
			element: withSuspense(FaqList),
			handle: {
				title: '자주 묻는 질문',
				subTitle: '락앤런 자주 묻는 질문'
			}
		},
		{
			path: paths.mainSection.faq.detail.path,
			element: withSuspense(FaqDetail),
			handle: {
				isGoBack: true,
				title: '자주 묻는 질문 상세정보',
				subTitle: '메인섹션 > 자주 묻는 질문 > 상세정보'
			}
		},
	]
};
